import React from 'react';
import {Link} from "react-router-dom";

import styles from './NoActiveOrders.module.scss';
import noActiveOrders from '../../../constants/images/no-active-orders.svg';
import {MAIN_ROUTES} from "../../../routing/main_routes";

const NoActiveOrders = () => {
    return (
        <div className={styles.noActiveOrders_wrapper}>
            <div className={styles.noActiveOrders_wrapper_content}>
                <div>
                    <img src={noActiveOrders} alt="cleaning workers cleaning house with mop"/>
                </div>

                <div className={styles.noActiveOrders_wrapper_content_description}>
                    <div className={styles.noActiveOrders_wrapper_content_description_titleContainer}>
                        <h2>Немає активних замовлень</h2>
                        <p>Заповніть форму замовлення та знайдіть свого клінера.</p>
                    </div>

                    <Link to={MAIN_ROUTES.CREATE_ORDER}>
                        <button className={styles.noActiveOrders_wrapper_content_description_button}>Замовити прибирання</button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NoActiveOrders;